$hardware-options-background: '#111C27' !default;
$hardware-options-border: 2px solid #111C27 !default;
$hardware-options-title-color: '#B7CDDF' !default;

@mixin background {
  background: #{$hardware-options-background};
  border: #{$hardware-options-border};
}

@mixin content {
  .title {
    color: #{$hardware-options-title-color};
  }
}

.hardware-options-row {
  .hardware-options-row-block {
    @include background;
    .drain-pump-hold-time {
      .content {
        @include content;
      }
    }
    .drain-pum-run-time-max {
      .content {
        @include content;
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/settings/machine-settings/hardware-options/hardware-options-theme.scss